import DashPlayer from '@player/src/players/dashPlayer';

class VliteDashplayer extends DashPlayer{

_filterRequests(type,request){
    if (type == this._shaka.net.NetworkingEngine.RequestType.LICENSE){
              request.headers["X-Mob-Meta-Drmtoken"] = this._content._drmToken;
              request.headers["Content-Type"] = "application/octet-stream";
              request.headers["Accept"] = "application/octet-stream";
              request.allowCrossSiteCredentials = true;
    }      
}


}




export default VliteDashplayer;